import { useState } from "react";
import { Icon, Popover } from "orcs-design-system";
import { copyToClipboard } from "src/util/embedUtils";
import { getFaviconUrl } from "src/util/url";

type GitHubCompareLinkProps = {
  commitHash: string | null | undefined;
  buildNumber: string | null | undefined;
  repoUrl: string;
};

const GitHubCompareLink = ({
  commitHash,
  buildNumber,
  repoUrl,
}: GitHubCompareLinkProps) => {
  const [copied, setCopied] = useState(false);
  const [faviconError, setFaviconError] = useState(false);

  if (!commitHash || commitHash.toUpperCase() === "NETLIFY") {
    return null;
  }

  const compareUrl = `${repoUrl}/compare/${commitHash}...master`;
  const faviconUrl = getFaviconUrl(repoUrl);
  const showFavicon = faviconUrl && !faviconError;

  const handleCopy = async () => {
    const success = await copyToClipboard(compareUrl);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Popover
      text={
        copied
          ? "Copied!"
          : "Click to copy compare URL to clipboard against master"
      }
      direction="top"
      width="200px"
    >
      <button
        type="button"
        onClick={handleCopy}
        aria-label="Compare against master on GitHub"
        data-testid={`github-compare-${buildNumber}`}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "2px 4px",
          marginLeft: "4px",
          display: "inline-flex",
          alignItems: "center",
          opacity: 0.6,
          transition: "opacity 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = "0.6";
        }}
      >
        {showFavicon ? (
          <img
            src={faviconUrl}
            alt="GitHub"
            referrerPolicy="no-referrer"
            style={{ width: "14px", height: "14px", objectFit: "contain" }}
            onError={() => setFaviconError(true)}
          />
        ) : (
          <Icon icon={["fab", "github"]} style={{ fontSize: "14px" }} />
        )}
      </button>
    </Popover>
  );
};

export default GitHubCompareLink;
